export const environment = {
  production: false,
  apiUrl: 'https://merckapi.loymarkservices.com/api',
  pageSize: 10,
};
